import mutations from "./mutations";
import actions from "./actions";

export default {
  namespaced: true,
  state: {
    logs: [],
    totalLogs: null,
    tableLoading: false,
    perPageForLogs: 5,
    currentPageForLogs: 1,
    searchQuery: "",
    filterDate: "",
    filterStatus: "",
  },
  actions,
  mutations,
};
